// Generated by purs version 0.15.16
import * as Concur_Core from "../Concur.Core/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Control_MultiAlternative from "../Control.MultiAlternative/index.js";
import * as Control_ShiftMap from "../Control.ShiftMap/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
var viewAdapter = function (f) {
    return function (ps) {
        return function (vs) {
            return [ f(ps)(vs) ];
        };
    };
};
var elLeafArr = function (dictLiftWidget) {
    var liftWidget = Concur_Core_LiftWidget.liftWidget(dictLiftWidget);
    return function (dictFunctor) {
        var map = Data_Functor.map(dictFunctor);
        return function (dictFunctor1) {
            var map1 = Data_Functor.map(dictFunctor1);
            return function (e) {
                return function (props) {
                    return liftWidget(Concur_Core.mkLeafWidget(function (h) {
                        return [ e(map(map1(h))(props)) ];
                    }));
                };
            };
        };
    };
};
var elLeaf = function (dictLiftWidget) {
    var liftWidget = Concur_Core_LiftWidget.liftWidget(dictLiftWidget);
    return function (dictFunctor) {
        var map = Data_Functor.map(dictFunctor);
        return function (dictFunctor1) {
            var map1 = Data_Functor.map(dictFunctor1);
            return function (e) {
                return function (props) {
                    return liftWidget(Concur_Core.mkLeafWidget(function (h) {
                        return e(map(map1(h))(props));
                    }));
                };
            };
        };
    };
};
var elArr = function (dictShiftMap) {
    var shiftMap = Control_ShiftMap.shiftMap(dictShiftMap);
    return function (dictFunctor) {
        var map = Data_Functor.map(dictFunctor);
        return function (dictFunctor1) {
            var map1 = Data_Functor.map(dictFunctor1);
            return function (e) {
                return function (props) {
                    return shiftMap(function (f) {
                        return function (w) {
                            return Concur_Core.mkNodeWidget(function (h) {
                                return function (v) {
                                    return viewAdapter(e)(map(map1(function ($41) {
                                        return h(f($41));
                                    }))(props))(v);
                                };
                            })(w);
                        };
                    });
                };
            };
        };
    };
};
var el = function (dictShiftMap) {
    var shiftMap = Control_ShiftMap.shiftMap(dictShiftMap);
    return function (dictFunctor) {
        var map = Data_Functor.map(dictFunctor);
        return function (dictFunctor1) {
            var map1 = Data_Functor.map(dictFunctor1);
            return function (e) {
                return function (props) {
                    return shiftMap(function (f) {
                        return function (w) {
                            return Concur_Core.mkNodeWidget(function (h) {
                                return function (v) {
                                    return e(map(map1(function ($42) {
                                        return h(f($42));
                                    }))(props))(v);
                                };
                            })(w);
                        };
                    });
                };
            };
        };
    };
};
var el$prime = function (dictShiftMap) {
    var el1 = el(dictShiftMap);
    return function (dictMultiAlternative) {
        var orr = Control_MultiAlternative.orr(dictMultiAlternative);
        return function (dictFunctor) {
            var el2 = el1(dictFunctor);
            return function (dictFunctor1) {
                var el3 = el2(dictFunctor1);
                return function (e) {
                    return function (props) {
                        var $43 = el3(e)(props);
                        return function ($44) {
                            return $43(orr($44));
                        };
                    };
                };
            };
        };
    };
};
var elArr$prime = function (dictShiftMap) {
    var el1 = el(dictShiftMap);
    return function (dictMultiAlternative) {
        var orr = Control_MultiAlternative.orr(dictMultiAlternative);
        return function (dictFunctor) {
            var el2 = el1(dictFunctor);
            return function (dictFunctor1) {
                var el3 = el2(dictFunctor1);
                return function (e) {
                    return function (props) {
                        var $45 = el3(viewAdapter(e))(props);
                        return function ($46) {
                            return $45(orr($46));
                        };
                    };
                };
            };
        };
    };
};
export {
    viewAdapter,
    el,
    elArr,
    elLeaf,
    elLeafArr,
    el$prime,
    elArr$prime
};
//# sourceMappingURL=index.js.map
